import { render } from "./countrydistribute.vue?vue&type=template&id=437e87ce&scoped=true"
import script from "./countrydistribute.vue?vue&type=script&lang=js"
export * from "./countrydistribute.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437e87ce"]])

export default __exports__